<template>
  <div>
		<div class="container">
			<nav-header />
		</div>
    <span class="d-md-none d-lg-block border-bottom"></span>
    <hr/>
		<div class="container">
			<main>
				<router-view/>
			</main>
		</div>
  </div>

</template>

<script>

	import NavHeader from '@/views/nav/NavHeader'
	import { authService, authMutations, sessionMonitor } from '@/auth'

export default {
	name: "HomeView",
	components: { NavHeader },
  computed: {
    isDashboardActive() {
      return this.$router.currentRoute.value.fullPath == '/' ? 'active' : ''
    },
    isFilesActive() {
      return this.$router.currentRoute.value.fullPath.indexOf('/financials') == 0 ? 'active' : ''
    },
    isCompanyActive() {
      return this.$router.currentRoute.value.fullPath.indexOf('/admin/company') == 0 ? 'active' : ''
    },
    isUserActive() {
      return this.$router.currentRoute.value.fullPath.indexOf('/admin/user') == 0 ? 'active' : ''
		}
  },
  methods: {
    async logout() {
      try {
        const result = await authService.logout()
        sessionMonitor.stop()
        authMutations.reset()
        if (result?.logoutUrl) {
          window.location.href = result.logoutUrl
        } else {
          this.$router.push('/login')
        }
      } catch (e) {
        authMutations.reset()
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>

</style>
